/**
 * Sponsors reducer.
 * @module reducers/sponsors/sponsors
 */

import {
  CREATE_SPONSOR,
  DELETE_SPONSOR,
  GET_SPONSOR,
  LIST_SPONSORS,
  UPDATE_SPONSOR,
} from '../constants/ActionTypes';

const getSponsors = () => {
  // function to get sponsors from backend if needed
  const testsponsor = {
    title: 'Freistaat Sachsen',
    url: 'http://sachsen.de',
    logo: '/de/aktuelles/bilder-sonstige/signet_gruen_mini_homepage.jpf/@@images/image-200-63dd43084f16278ed4cf85cab1fc4cd5.gif',
    id: 'spon1',
    current: true,
  };
  const testsponsor2 = {
    title: 'Akademienunion',
    url: 'http://test.org',
    logo: '/de/aktuelles/bilder-sonstige/logo-akademienunion/@@images/image-800-f28c8c9edf08cdcb92543171cd44f4d3.jpeg',
    id: 'spon2',
    current: true,
  };
  const testsponsor3 = {
    title: 'SAB',
    url: 'http://testsponsor.org',
    logo: '/de/aktuelles/SAB_LogoDeskriptor_Farbepos_sRGB.png/@@images/image-400-cefbe6ae2c1c0f6f816d110048fc302c.png',
    id: 'spon3',
    current: true,
  };
  const testsponsor4 = {
    title: 'BMBF',
    url: 'http://test.org',
    logo: '/de/aktuelles/Logos_BMBF_Wissenschaftsjahr.jpg/@@images/image-400-ce959401c6244fae3d8f27b5064f94c9.jpeg',
    id: 'spon4',
    current: true,
  };
  return [testsponsor, testsponsor2, testsponsor3, testsponsor4];
};

const initialState = {
  sponsor: {},
  sponsors: {},
  create: {
    error: null,
    loaded: false,
    loading: false,
  },
  get: {
    error: null,
    loaded: false,
    loading: false,
  },
  list: {
    error: null,
    loaded: false,
    loading: false,
  },
  delete: {
    error: null,
    loaded: false,
    loading: false,
  },
  update: {
    error: null,
    loaded: false,
    loading: false,
  },
};

/**
 * Get request key
 * @function getRequestKey
 * @param {string} actionType Action type.
 * @returns {string} Request key.
 */
function getRequestKey(actionType) {
  return actionType.split('_')[0].toLowerCase();
}

/**
 * Users reducer.
 * @function sponsors
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export function sponsors(state = initialState, action = {}) {
  switch (action.type) {
    case `${CREATE_SPONSOR}_PENDING`:
    case `${DELETE_SPONSOR}_PENDING`:
    case `${GET_SPONSOR}_PENDING`:
    case `${LIST_SPONSORS}_PENDING`:
    case `${UPDATE_SPONSOR}_PENDING`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          loading: true,
          loaded: false,
          error: null,
        },
      };
    case `${GET_SPONSOR}_SUCCESS`:
      return {
        ...state,
        sponsor: action.result,
        [getRequestKey(action.type)]: {
          loading: false,
          loaded: true,
          error: null,
        },
      };
    case `${LIST_SPONSORS}_SUCCESS`:
      return {
        ...state,
        sponsors: action.result,
        [getRequestKey(action.type)]: {
          loading: false,
          loaded: true,
          error: null,
        },
      };
    case `${CREATE_SPONSOR}_SUCCESS`:
    case `${DELETE_SPONSOR}_SUCCESS`:
    case `${UPDATE_SPONSOR}_SUCCESS`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          loading: false,
          loaded: true,
          error: null,
        },
      };
    case `${GET_SPONSOR}_FAIL`:
      return {
        ...state,
        sponsor: {},
        [getRequestKey(action.type)]: {
          loading: false,
          loaded: false,
          error: action.error,
        },
      };
    case `${LIST_SPONSORS}_FAIL`:
      return {
        ...state,
        sponsors: {},
        [getRequestKey(action.type)]: {
          loading: false,
          loaded: false,
          error: action.error,
        },
      };
    case `${CREATE_SPONSOR}_FAIL`:
    case `${DELETE_SPONSOR}_FAIL`:
    case `${UPDATE_SPONSOR}_FAIL`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          loading: false,
          loaded: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
}
